/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="afc0d603-a4d3-499a-ab4f-55bfd2d872b9" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="b48ba7ca-e016-4cec-acf4-b67ca0eaaa55" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="f00c7a79-348e-4f8b-be3a-c767986abd6f">
              <path id="b64f8e41-f59d-497b-ac43-074376ced0a8" d="M12,2h0l8,2.35V7.64a14.69,14.69,0,0,1-3,8.69,22.82,22.82,0,0,1-4.75,4.61h0l-.27.18-.27-.18A22.57,22.57,0,0,1,7,16.33a14.72,14.72,0,0,1-3-9.1V4.36Zm0,1L5,5.11V7.23a13.72,13.72,0,0,0,2.76,8.48A24.08,24.08,0,0,0,12,19.91a23.8,23.8,0,0,0,4.24-4.21A13.69,13.69,0,0,0,19,7.23V5.11Zm3.19,4.58.71.71-4.57,4.61L8.58,10.18l.7-.7,2.05,2Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="f95f14fc-7d32-44d9-ac23-e3d40ed9dede">
          <g id="a98a3a4f-8142-4e34-bb0a-a9af8df76a15">
            <g id="bc132c81-c374-46e4-a5d6-15e5bbb2225c">
              <path id="ef5626a7-e93c-4b83-bd9b-89a5288e9b74" d="M12,2h0l8,2.35V7.64a14.69,14.69,0,0,1-3,8.69,22.82,22.82,0,0,1-4.75,4.61h0l-.27.18-.27-.18A22.57,22.57,0,0,1,7,16.33a14.72,14.72,0,0,1-3-9.1V4.36Zm0,1L5,5.11V7.23a13.72,13.72,0,0,0,2.76,8.48A24.08,24.08,0,0,0,12,19.91a23.8,23.8,0,0,0,4.24-4.21A13.69,13.69,0,0,0,19,7.23V5.11Zm3.19,4.58.71.71-4.57,4.61L8.58,10.18l.7-.7,2.05,2Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#b48ba7ca-e016-4cec-acf4-b67ca0eaaa55)' }}>
              <g id="a54b4004-e9bc-4a38-ae4f-4fe1dabc6c1d">
                <rect id="a67708dc-c9aa-4902-8283-67624c8720d0" width="24" height="24" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#b48ba7ca-e016-4cec-acf4-b67ca0eaaa55)' }}>
              <rect id="edb93ec4-4ee5-4950-9e14-5896e5f0ce35" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithCheckmarkIcon';

export default Icon;
